// 19.1.3.10 Object.is(value1, value2)
var $def = require('./$.def');
$def($def.S, 'Object', {is: require('./$.same-value')});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.object.is.js
 ** module id = 286
 ** module chunks = 0
 **/